import { cn } from "@readouts/utils";
import { CheckIcon } from "lucide-react";

export const PASSWORD_RULES = [
  {
    id: "length",
    label: "Alespoň 8 znaků",
    test: (value: string) => value.length >= 8,
  },
  {
    id: "uppercase",
    label: "Jedno velké písmeno",
    test: (value: string) => /[A-Z]/.test(value),
  },
  {
    id: "number",
    label: "Jedna číslice",
    test: (value: string) => /[0-9]/.test(value),
  },
] as const;

export function isPasswordValid(value: string) {
  return PASSWORD_RULES.every((rule) => rule.test(value));
}

export function PasswordRequirements({ password }: { password: string }) {
  return (
    <ul className="flex flex-col gap-1 mt-1.5">
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(password);
        return (
          <li
            key={rule.id}
            className={cn(
              "flex items-center gap-1.5 text-xs transition-colors",
              met ? "text-emerald-600" : "text-slate-400",
            )}
          >
            <span
              className={cn(
                "flex items-center justify-center h-3.5 w-3.5 rounded-full border shrink-0 transition-colors",
                met ? "bg-emerald-500 border-emerald-500" : "border-slate-300",
              )}
            >
              {met && <CheckIcon className="h-2.5 w-2.5 text-white" />}
            </span>
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
